import SetOrder from '@/pages/SetOrder'

export default {
    path: '',
    component: SetOrder,
    children: [
        {
            path: '/set/order/:ref',
            name: 'Set Order',
            component: SetOrder,
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/setorder.js